/*
 * Free gift automation for Maison Jearom (replaces the unreliable EG app).
 * When the qualifying cart total (everything EXCEPT the gift line) reaches the
 * threshold, the gift variant is auto-added; below it, it's removed.
 * The gift is made free by a native Shopify automatic "Buy X Get Y" discount
 * ("🎁 Cadeau dès 50€"), so pricing is enforced server-side (cart + checkout).
 *
 * Robust by design:
 *  - identifies the gift only by variant id + a line property, so a genuine
 *    purchase of the same variant is never mistaken for the gift;
 *  - never counts the gift toward the threshold (no self-trigger loop);
 *  - single-flight guard + pending re-run so rapid cart events can't double-add;
 *  - normalises the gift to a single unit;
 *  - re-renders the drawer through the theme's own renderContents().
 */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 54072015716693;   // Shampoing Fortifiant – Sans écrin
  var GIFT_THRESHOLD  = 5000;             // 50,00 € expressed in cents
  var GIFT_PROP_KEY   = '_free_gift';
  var GIFT_PROP_VAL   = 'true';

  var inFlight = false;
  var pending  = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function isGiftLine(item) {
    return item.id === GIFT_VARIANT_ID &&
           item.properties && item.properties[GIFT_PROP_KEY] == GIFT_PROP_VAL;
  }

  function qualifyingTotal(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      // exclude our gift line AND any leftover EG gift line (_Gifted)
      var isOtherGift = item.properties && item.properties._Gifted;
      if (!isGiftLine(item) && !isOtherGift) total += item.final_line_price;
    });
    return total;
  }

  function findGift(cart) {
    var found = null;
    (cart.items || []).forEach(function (item) { if (isGiftLine(item)) found = item; });
    return found;
  }

  function sectionsToRender() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { return drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return ['cart-drawer'];
  }

  function applySections(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
      try { drawer.renderContents(state); return; } catch (e) {}
    }
    if (state && state.sections && state.sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
      var src = doc.querySelector('.drawer__inner');
      var dst = document.querySelector('cart-drawer .drawer__inner');
      if (src && dst) dst.innerHTML = src.innerHTML;
    }
  }

  function postCart(url, payload) {
    payload.sections = sectionsToRender();
    payload.sections_url = window.location.pathname;
    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function addGift() {
    var props = {}; props[GIFT_PROP_KEY] = GIFT_PROP_VAL;
    return postCart('cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: props }] });
  }

  function removeGift(key) {
    return postCart('cart/change.js', { id: key, quantity: 0 });
  }

  function run() {
    return getCart().then(function (cart) {
      var qt   = qualifyingTotal(cart);
      var gift = findGift(cart);

      if (qt >= GIFT_THRESHOLD && !gift) {
        return addGift().then(applySections);
      }
      if (qt < GIFT_THRESHOLD && gift) {
        return removeGift(gift.key).then(applySections);
      }
      if (gift && gift.quantity > 1) { // normalise to a single free unit
        return removeGift(gift.key).then(addGift).then(applySections);
      }
      return null;
    });
  }

  function reconcile() {
    if (inFlight) { pending = true; return; }
    inFlight = true;
    run()
      .catch(function (e) { if (window.console) console.error('[free-gift]', e); })
      .then(function () {
        inFlight = false;
        if (pending) { pending = false; reconcile(); }
      });
  }

  function hook() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === 'free-gift') return;
        reconcile();
      });
    }
    document.addEventListener('cart:updated', reconcile);
    document.addEventListener('cart-drawer:open', reconcile);
    reconcile(); // align on initial load
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hook);
  } else {
    hook();
  }
})();
